import React, { useState } from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import LinearProgress from '../../components/Progress/LinearProgress';
import Alert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import IconButtonsGroup from '../../components/ButtonGroup/ButtonGroup';
import { colors,fontFamily,fontSizes} from '../../styles/variables'
import {IFeedbackRequest,IFeedbackResponse} from '../../typings';
import api from '../../lib/baseAxios';

const contactPageLogo = require("../../images/recordinglogo.png")
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
        flexGrow: 1,
        margin: 0,
        padding: 0,
        height: '100vh',
        backgroundColor: colors.white
    },
    headetMainDiv:{
        display:'flex',
        justifyContent:'center',
        flexDirection:'row'
    },
    leftBottomLine:{
        borderBottom:'5px',
        borderBottomStyle:'solid',
        borderImage: 'linear-gradient(94deg, #ED5565 0%, #DA4453 100%)',
        borderImageSlice: '1', // note the quotes and the semi-colon.
        width:'20%',
        height:85,
    },
    rightBottonLine:{
        borderBottom:'5px',
        borderBottomStyle:'solid',
        borderImage: 'linear-gradient(94deg, #ED5565 0%, #DA4453 100%)',
        borderImageSlice: '1', // note the quotes and the semi-colon.
        width:'20%',
        height:85,
    },
    headerText:{
        fontFamily:fontFamily.poppins,
        fontSize:fontSizes.lg.regular,
        fontWeight:'bold',
        color:'black',
        textAlign:'center',
        paddingLeft:'3rem',
        paddingRight:'3rem',
        paddingTop:'3.5rem',
        '@media only screen and (max-width: 959px)': {
            fontSize:'1.5rem',
            paddingLeft:'2rem',
            paddingRight:'2rem',
        },
        // paddingBottom:'2%'
    },
    headingDescription:{
        fontFamily:fontFamily.poppins,
        fontWeight:'lighter',
        textAlign:'center',
        fontSize: fontSizes.md.regular,
        paddingRight:50,
        paddingLeft:50,
        paddingTop:30,
        lineHeight:2    
    },
    responseText:{
      fontFamily:`url('https://fonts.googleapis.com/css2?family=Poppins')`,
      fontWeight:'lighter',
      textAlign:'center',
      color:'red',
      fontSize:17,
      paddingRight:50,
      paddingLeft:50,
      paddingTop:30,
      lineHeight:2    
  },
    textFieldsMainDiv:{
        display:'flex',
        flexDirection:'row',
        justifyContent:'center',
        alignItems:'center',
        alignContent:'center',
        paddingLeft:'10%',
        paddingRight:'10%',
        paddingTop:'3%',
        paddingBottom:'1%'
    },
    textareaMainDiv:{
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        paddingLeft:'10%',
        paddingRight:'10%'
    },
    textArea:{
        borderRadius:10,
        width:'65rem',
        padding:20,
        boxShadow:'0px 3px 10px #00000029;',
        borderColor:'#00000029',
        // pointerEvents:'none',
        resize:'none',
        outline:'none'
    },
    submitButton:{
        color: '#fff',
        background: 'linear-gradient(98deg, #414141 0%, #525252 100%)',
        borderRadius: 37,
        padding: '1% 7%',
        textTransform: 'uppercase',
        '& .MuiTouchRipple-root span': {
            backgroundColor: 'transparent!important',
            color: '#fff',
            // opacity: 0.3,
          },
        '&.MuiButton-contained':{
            outline:'none'
        },
    },
    submitButtonDiv:{
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        alignContent:'center',
        padding: '35px 25px 20px 25px',
    },
    bottomLogoDiv:{
        display:'flex',
        justifyContent:'center',
        alignContent:'center'
    },
    bottomLogoImage:{
        width:130,
    },
    bottomLine:{
        borderBottom:'3px',
        borderBottomStyle:'solid',
        borderBottomColor: '#A5A5A5',
        borderImageSlice: '1',
        width:'30%',
        // marginLeft:30,
        alignItems:'center',
        opacity:0.5
        // height:85,  
    },
    bottomLineMian:{
        display:'flex',
        padding:30,
        justifyContent:'center',
        alignContent:'center',
        alignItems:'center'
    },
    copyrightText:{
        display:'flex',
        fontFamily:fontFamily.poppins,
        justifyContent:'center',
        fontWeight:'lighter',
        fontSize:10,
        textAlign:'center'
    },
    feedbackErrorText: {
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
      fontWeight: 'lighter',
      textAlign: 'center',
      color: '#DA4453',
      fontSize: '0.75rem',
      paddingRight: 50,
      paddingLeft: 50,
      paddingTop: 10,
      lineHeight: 2
    },
    responseSuccessText: {
      fontFamily: `url('https://fonts.googleapis.com/css2?family=Poppins')`,
      fontWeight: 'lighter',
      textAlign: 'center',
      color: '#4BB543',
      fontSize: 15,
      paddingRight: 50,
      paddingLeft: 50,
      paddingTop: 30,
      lineHeight: 2
    },
    responseErrorText: {
      fontFamily: `url('https://fonts.googleapis.com/css2?family=Poppins')`,
      fontWeight: 'lighter',
      textAlign: 'center',
      color: '#DA4453',
      fontSize: 15,
      paddingRight: 50,
      paddingLeft: 50,
      paddingTop: 30,
      lineHeight: 2
    },
    responseAlert: {
     // marginBottom: '1.5rem',
      textAlign:'center',
        paddingLeft:'30rem',
        paddingRight:'30rem',
        paddingTop:'1.5rem',
        '@media only screen and (max-width: 959px)': {
            fontSize:'1.5rem',
            paddingLeft:'2rem',
            paddingRight:'2rem',
        },
    },
    responseText2: {
      textAlign: 'center'

    },

    text: {
        margin: theme.spacing(1.5),
        borderRadius: '0.3125rem',
  
        backgroundColor: theme.palette.common.white,
        '& .MuiFormHelperText-contained': {
          color: '#DA4453 !important',
          fontFamily:fontFamily.poppins,
          height:'30px',
        },
        '& .MuiFormHelperText-root': {
          fontsize: 20,
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: '#A5A5A5',
          Color: '#A5A5A5',
          // margin:'1.25rem'
        },
  
        '& .MuiInputBase-input': {
          width: '30rem',
          fontsize: '0.625rem',
        },
        '& label.Mui-focused': {
          color: '#A5A5A5 ',
        },
        '&:hover': {
          borderColor: colors.white,
          borderWidth: '0.125rem',
          outline: 'none',
        },
        '@media only screen and (max-width: 575px)': {
          '& .MuiInputBase-input': {
            width: '25rem',
            fontsize: '2rem',
          },
        },
      },
  })
);

const ContactUs = () => {
  const classes = useStyles();
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [feedback, setFeedback] = useState('');
  const [isEmailError, setIsEmailError] = useState(false);
  const [isNameError, setIsNameError] = useState(false);
  const [isFeedbackError, setIsFeedbackError] = useState(false);
  const [feedbackResponse,setFeedbackResponse]=useState<IFeedbackResponse>();
  const [isLoading, setIsLoading]=useState(false);

  const validateEmail=(input:any)=>{
    const reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    const result = reg.test(input);
    const b1 = input === '';
    const error = !result && !b1;
    setIsEmailError(error);
  }

  const handleEmailChange = (event: { target: { value: any; }; }) => {
    setEmail( event.target.value );
    validateEmail(event.target.value);
  };

  const handleNameChange = (event: { target: { value: any; }; }) => {
    setName( event.target.value );
    const error=event.target.value === '' ;
    setIsNameError(error)
  };

  const handleFeedbackChange = (event: { target: { value: any; }; }) => {
    setFeedback( event.target.value );
    const error=event.target.value === '' ;
    setIsFeedbackError(error);
  };

  const resetTextFields=()=>{
    setEmail('');
    setName('');
    setFeedback('');
    setIsEmailError(false);
    setIsNameError(false);
  }

  const handleClick = async () => {
    // setFeedbackResponse({
    //   data: {},
    //   message: "Please enter all required details before submitting your feedback.",
    //   success: false,
    // });
    !name && setIsNameError(true);
    !email && setIsEmailError(true);
    !feedback && setIsFeedbackError(true);

    if (!name || !email || !feedback) return null;

    setIsLoading(true);
    const data: IFeedbackRequest = { name, email, feedback };
    await api.post("/feedback", data)
      .then(result => {
        setFeedbackResponse(result.data);
        resetTextFields();
        setIsLoading(false);
        resetTextFields();
      })
      .catch(err => {
        setFeedbackResponse({
          data: {},
          message: "Something went wrong. Please try again in few minutes.",
          success: false,
        });
        setIsLoading(false);
      })
    return null;
  };


  const ResponseMessage = () => {
  
    if (feedbackResponse) {
      if (feedbackResponse.success) {
        return (
          <div>
            <Alert severity="success" className={classes.responseText2}>{feedbackResponse.message}</Alert>
          </div>
        );
      }
     else if (!feedbackResponse.success) {
        return (
          <div>
            <Alert severity="error" className={classes.responseText2}>{feedbackResponse.message}</Alert>
          </div>
        );
      }
    }
    //return null;
  };

    return (
        <div className={classes.root} id="Contact" >
            <div className={classes.headetMainDiv}>
                <div className={classes.leftBottomLine}></div>
                <div className={classes.headerText}  >Contact us</div>
                <div className={classes.rightBottonLine}></div>
            </div>
            <div className={classes.headingDescription}>Send us any questions you have or any suggestions to improve the product. we are here to listen<br/> you through the any issues or suggestions.</div>
            {/* <div className={feedbackResponse && feedbackResponse.success ? classes.responseSuccessText : classes.responseErrorText}> <b>{feedbackResponse && feedbackResponse.message}</b></div> */}
           
            <div>
              {isLoading && <LinearProgress />}
            </div>         
            <div className={classes.textFieldsMainDiv}>
              <TextField
                InputLabelProps={{
                  style: { color: colors.darkGray, fontFamily:`url('https://fonts.googleapis.com/css2?family=Poppins')`, fontSize: '15px' },
                }}
                name="name"
                value={name}
                onChange={(e)=>handleNameChange(e)}
              helperText={isNameError ? 'Name field cannot be empty. Please enter your name.' : <div>{ '              '}</div>}
                disabled={false}
                label="Full name"
                variant="outlined"
                size="small"
                type="text"
                className={classes.text}
               />

               <TextField
                 InputLabelProps={{
                   style: { color: colors.darkGray, fontFamily:`url('https://fonts.googleapis.com/css2?family=Poppins')`, fontSize: '15px' },
                 }}
                 name="email"
                 value={email}
                 onChange={(e)=>handleEmailChange(e)}
                 helperText={
                   isEmailError
                     ? 'Invalid Email address. Please enter a correct email.'
                 : <div> {'       '} </div>
                 }
                 disabled={false}
                 label="Email"
                 variant="outlined"
                 size="small"
                 type="email"
                 className={classes.text}
                />
                  
            </div>
            <div className={classes.textareaMainDiv}>
                <TextareaAutosize  aria-label="minimum height" rowsMin={10} placeholder="" value={feedback}  onChange={(e)=>handleFeedbackChange(e)} className={classes.textArea} />
            </div>
            <div className={classes.feedbackErrorText}>
                {isFeedbackError && <b >Feeback field cannot be empty. Please enter anything. </b>}
            </div>

            <div className={classes.submitButtonDiv}>
                <Button variant="contained" className={classes.submitButton} onClick={()=>handleClick()} disabled={isLoading}>Submit</Button>
            </div>

          
            <div className={classes.responseAlert}>
                {ResponseMessage()}
            </div>

            <div style={{height:100}}></div>
            <div className={classes.bottomLogoDiv}>
                <img src={contactPageLogo} alt="bottomlogo" className={classes.bottomLogoImage}/>
            </div>
            <div className={classes.bottomLineMian}>
                <div className={classes.bottomLine}></div>
            </div>
            <div className={classes.copyrightText}>© Copyright 2020 By Meetrix</div>
            <div style={{display:'flex',justifyContent:'center'}}>
               <IconButtonsGroup/>
            </div>
            
            <div style={{height:100}}></div>
        </div>
    );
};
export default ContactUs;

//https://twitter.com/IoMeetrix
//https://www.linkedin.com/company/meetrixio
//https://www.facebook.com/meetrix